export const P0003605SensContactEnum = [
  { ref: 0, label: 'P0003605.senscontact.0' },
  { ref: 1, label: 'P0003605.senscontact.1' },
  { ref: 99, label: 'generic.byprocedure' },
];
